import React, {ChangeEvent, useEffect, useState} from "react";
import "./SendDocs.css";
import MySelect from "../../Components/MySelect/MySelect";
import FormDocMetadata from "../../Model/FormDocMetadata";
import AdditionnalMetadata from "../../Model/AdditionnalMetadata";
import Document from "../../Model/Document";
import { WebApi } from "../../WebApi/WebApi";
import { authAtom } from "../../../Connect/_state";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import swal from "sweetalert";
import { documentMetaListAtom, justSentDocsAtom, uploadedDocumentsAtom } from "../../LoadData/LoadData";
import Loc from "../../../Loc/Loc";

export function define_doc_object(documentMetaList: FormDocMetadata[], name: string, item: any, doc: any, newObject: boolean, modifyDoc: boolean = false) {
    if (newObject && modifyDoc) {
        return item;
    }
    let map = new Map<string, string | any>();
    documentMetaList.forEach((meta:FormDocMetadata, index: number) => {
        if (newObject) {
            if (meta.type === 3) {
                map.set(meta.name, meta.values[0])
            }
            else if (meta.type === 5) {
                let values: string[][] = meta.values.map((value: string) => { return (value.split(',')) })
                map.set(meta.name, values.map((value: string[]) => { return value[0]}))
            }
            else {
                map.set(meta.name, "");
            }
        }
        else if (meta.name === name) {
            map.set(meta.name, item);
        }
        else {
            let index: number = 0;
            let keys: string[] = Object.keys(doc);
            keys.forEach((key: string, i: number) => {
                if (key === meta.name) {
                    index = i;
                }
            })
            map.set(meta.name, Object.values(doc)[index])
        }
    })
    if (newObject) {
        map.set('file', {});
    }
    else if (name === 'file') {
        map.set('file', item);
    }
    else {
        let values = Object.values(doc);
        map.set('file', values[values.length - 1]);
    }
    let object = Object.fromEntries(map);
    return object;
}

function define_additionalMetas(documentMetaList: FormDocMetadata[], doc: {[k: string]: any;}) {
    let additionnalMetas: AdditionnalMetadata[] = [];
    documentMetaList.forEach((meta: FormDocMetadata, index: number) => {
        let additionnalMeta = new AdditionnalMetadata();
        additionnalMeta.name = meta.name;
        additionnalMeta.alias = meta.alias;
        additionnalMeta.value = Object.values(doc)[index];
        additionnalMetas.push(additionnalMeta);
    })
    return additionnalMetas;
}

function modify_doc_by_new_doc(documents: Document[], newDoc: Document) {
    let newDocuments: Document[] = [];
    documents.forEach((doc: Document) => {
        if (doc.id === newDoc.id) {
            newDocuments.push(newDoc);
        }
        else {
            newDocuments.push(doc);
        }
    })
    return newDocuments;
}

function add_new_doc(documents: Document[], newDoc: Document) {
    let newDocuments: Document[] = [];
    documents.forEach(doc => newDocuments.push(doc));
    newDocuments.push(newDoc);
    return newDocuments;
}

function define_value_from_metaname(doc: any, metaname: string) {
    let values: string[] = Object.values(doc);
    let keys: string[] = Object.keys(doc);
    let value: string = "";

    keys.forEach((key: string, index: number) => {
        if (key === metaname) {
            value = values[index];
        }
    })
    return value;
}

interface SendNewDocProps {
    closeModal(): void;
    modifyDoc: boolean;
    item?: any;
}

export default function SendNewDoc (props: SendNewDocProps) {
    const auth = useRecoilValue(authAtom);
    const [justSentDocs, setJustSentDocs] = useRecoilState(justSentDocsAtom);
    const documentMetaList = useRecoilValue(documentMetaListAtom);
    const setUploadedDocuments = useSetRecoilState(uploadedDocumentsAtom);
    const uploadedDocuments = useRecoilValue(uploadedDocumentsAtom);
    const webApi = new WebApi();
    const [doc, setDoc] = useState(define_doc_object(documentMetaList, "", props.item, {}, true, props.modifyDoc));
    const [docIsDefined, setDocIsDefined] = useState(false);
    const [name, setName] = useState("");
    const [error, setError] = useState("");
    const [isUploading, setIsUploading] = useState(false);
    const Id: number = props.modifyDoc ? parseInt(props.item.id) : 0;
    const [fileNumber, setFileNumber] = useState(Loc.trad().SendNewDocFileEmpty);

    const uploadDocumentRequest = (additionnalMetas: any[]) => {
        webApi.uploadDocument(auth.jwtToken, name, additionnalMetas, doc.file, props.modifyDoc, Id)
            .then((res: Document) => {
                setIsUploading(false);
                if (props.modifyDoc) {
                    setUploadedDocuments(modify_doc_by_new_doc(uploadedDocuments, res));
                    setJustSentDocs(modify_doc_by_new_doc(justSentDocs, res));
                }
                else {
                    setJustSentDocs(add_new_doc(justSentDocs, res));
                }
                const swalTitle: string = props.modifyDoc ? Loc.trad().SendNewDocModified :  Loc.trad().SendNewDocSent;
                swal({ title: swalTitle, icon: "success" });
                props.closeModal();
            })
            .catch(error => {
                setIsUploading(false);
                if (error.message === "Failed to fetch") {
                    error.message = Loc.trad().SendNewDocError;
                }
                setError(error.message);
            })
    }

    const HandleOnSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        setError("");
        setIsUploading(true);
        uploadDocumentRequest(define_additionalMetas(documentMetaList, doc));
    }

    const inputOnChange = (event: any, setDoc: React.Dispatch<React.SetStateAction<{[k: string]: any;}>>, name: string) => {
        setDoc(define_doc_object(documentMetaList, name, event.target.value, doc, false))
    }

    const handleFileInput = (event: ChangeEvent<HTMLInputElement>, setDoc: React.Dispatch<React.SetStateAction<{[k: string]: any;}>>) => {
        setError("");
        const input = event.target as HTMLInputElement;
        if (!input.files?.length) {
            setName("");
            return;
        }
        const file = input.files[0];
        const files = input.files;
        setDoc(define_doc_object(documentMetaList, 'file', files, doc, false));
        setName(file.name.split('.').slice(0, -1).join('.'));

        setFileNumber(files.length === 0 ? Loc.trad().SendNewDocFileEmpty : files.length === 1 ? files.length.toString() + " " + Loc.trad().SendNewDocFileSingular : files.length.toString() + " " + Loc.trad().SendNewDocFilePlural);
        // split('.') : fichier.nouveau.pdf -> ["fichier", "nouveau", "pdf"]
        // slice(0, -1) : ["fichier", "nouveau", "pdf"] -> ["fichier", "nouveau"]
        // join('.') : ["fichier", "nouveau"] -> "fichier.nouveau"
    }

    useEffect(() => {
        if (documentMetaList.length > 0 && !docIsDefined) {
            setDoc(define_doc_object(documentMetaList, "", props.item, {}, true, props.modifyDoc))
            setDocIsDefined(true);
        }
    }, [doc, docIsDefined, documentMetaList, props.item, props.modifyDoc])

    return (
        <div className="SendNewDoc">
            <form onSubmit={HandleOnSubmit} className="sendNewDocForm">
                {documentMetaList.map((meta: FormDocMetadata, id: number) => {
                    var title = meta.name === "Indice" ? Loc.trad().SendNewDocIndex : meta.name === "Status" ? Loc.trad().SendNewDocStatus : meta.name === "Commentary" ? Loc.trad().SendNewDocComment : meta.name;
                    switch(meta.type) {
                        case 1:
                            return (
                                <div className="form-group row" key={id}>
                                    <label className="col-sm-2 add-col col-form-label">{title}</label>
                                    <div className="col-sm-10 add-col">
                                        <input type="text" className="form-control" placeholder={meta.name}
                                            onChange={(event) => inputOnChange(event, setDoc, meta.name)} required
                                            value={define_value_from_metaname(doc, meta.name)}/>
                                    </div>
                                </div>
                            )
                        case 2:
                            return (
                                <div className="commentaires" key={id}>
                                    <label>{title}</label>
                                    <textarea className="form-control" onChange={(event) => inputOnChange(event, setDoc, meta.name)}
                                    value={define_value_from_metaname(doc, meta.name)}></textarea>
                                </div>
                            )
                        case 3:
                            return (
                                <div className="form-group row" key={id}>
                                    <label className="col-sm-2 add-col col-form-label">{title}</label>
                                    <div className="col-sm-10 add-col">
                                    <MySelect title={title} options={[define_value_from_metaname(doc, meta.name), meta.values].flat()} simpleForm={true} sendDocForm={true}
                                    setDoc={setDoc} name={meta.name} documentMetaList={documentMetaList}
                                    doc={doc}></MySelect>
                                    </div>
                                </div>
                            )
                        case 4:
                            return (
                                <div className="form-group row" key={id}>
                                    <label className="col-sm-2 add-col col-form-label">{title}</label>
                                    <div className="col-sm-10 add-col">
                                        <input type="date" className="form-control" value={define_value_from_metaname(doc, meta.name)}
                                            onChange={(event) => inputOnChange(event, setDoc, meta.name)} required />
                                    </div>
                                </div>
                            )
                        case 5:
                            let values: string[][] = meta.values.map((value: string) => { return (value.split(',')) })
                            return (
                                <div className="multipleMySelect" key={id}>
                                    {/*meta.*/values /* vérif si meta.values est null */ && /*meta.*/values.map((value: string[], index: number) => {
                                        return (
                                            <MySelect key={index} title={index === 0 ? title : ""} options={value} sendDocForm={true}
                                            setDoc={setDoc} name={meta.name} documentMetaList={documentMetaList}
                                            doc={doc}></MySelect>
                                        )
                                    })}
                                </div>
                            )
                        default: return (<div>{Loc.trad().SendNewDocNotSupported}</div>)
                    }
                })}
                <div className="mb-3">
                    <div>
                        <label htmlFor="formFileMultiple" className="btn btn-secondary">{Loc.trad().SendNewDocFile}</label> 
                        <label htmlFor="formFileMultiple" style={{paddingLeft:"10px"}}>{fileNumber}</label> 
                    </div>
                    <input className="form-control" hidden multiple type="file" id="formFileMultiple" onChange={(event) => handleFileInput(event, setDoc)} required/>
                    <div style={{color: "red"}}>{error}</div>
                </div>
                <div className="text-right">
                    {
                        isUploading ?
                        <button className="btn btn-success btn-lg" disabled>{props.modifyDoc ? Loc.trad().SendNewDocModifying : Loc.trad().SendNewDocSending}<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></button> :
                        <button className="btn btn-success btn-lg" type="submit" disabled={documentMetaList.length === 0}>
                            {props.modifyDoc ? Loc.trad().SendNewDocModify : Loc.trad().SendNewDocSend}
                        </button>
                    }
                </div>
            </form>
        </div>
    )
}